import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.staging.seek.com',
    clientDomain: 'hk.staging.jobsdb.com',
    clientId: 'MtpqPEwQV2SD7hfuX8kUav1BVLrv0wGB',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSDB,
    contactUs: {
        en: 'https://hk.jobsdb.com/en-hk/pages/regional-coverage/',
    },
    siteName: siteNames.candidate.jobsdb.hk,
    zone: getZoneFromSite(siteNames.candidate.jobsdb.hk),
    product: Product.SEEK,
};
//# sourceMappingURL=hk_staging_jobsdb_com.js.map